export * from './shop'



// WEBPACK FOOTER //
// ./src/components/header/promos/index.js